/**
 * Modulo para los tipos
 */
import TiposActionsService from "./tiposActionsService";
import DialogEditTipoCtrl from "./edit/dialogEditTipoCtrl";
import DialogEditConfigTipoCtrl from "./edit-config/dialogEditConfigTipoCtrl";
import DialogEditConfigTipoDistrCtrl from "./edit-config-distrito/dialogEditConfigTipoDistritoCtrl";
import angular from 'angular';
import ngResourceModuleName from 'angular-resource';

const TiposModule = angular
    .module('tipos', ['app', ngResourceModuleName])
    .service('TiposActionsService', TiposActionsService)
    .controller('DialogEditTipoCtrl', DialogEditTipoCtrl)
    .controller('DialogEditConfigTipoCtrl', DialogEditConfigTipoCtrl)
    .controller('DialogEditConfigTipoDistrCtrl', DialogEditConfigTipoDistrCtrl)
;

export default TiposModule;